import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';

// Shared subscription-status hook for undergrad students.
// Returns: { status: 'loading'|'active'|'grace'|'expired'|'none',
//            daysLeft, endDate, isSubscribed }
// Non-students are always treated as 'active' (no gating).
export default function useSubscription() {
  const { isStudent, currentUser } = useAuth();
  const [state, setState] = useState({ status: 'loading', daysLeft: 0, endDate: null });

  // 200L/300L students are on the free peer-led track — never gated.
  const isPeerLed = isStudent && ['200L', '300L'].includes(currentUser?.level);

  useEffect(() => {
    if (!isStudent || isPeerLed) { setState({ status: 'active', daysLeft: 0, endDate: null }); return; }

    let cancelled = false;
    // Lightweight status endpoint — computed server-side, far smaller than
    // pulling the whole payments history on every page.
    api.get('/payments/subscription/status').then(r => {
      if (cancelled) return;
      const { status = 'none', daysLeft = 0, endDate = null } = r.data || {};
      setState({ status, daysLeft, endDate });
    }).catch(() => { if (!cancelled) setState({ status: 'none', daysLeft: 0, endDate: null }); });

    return () => { cancelled = true; };
  }, [isStudent, isPeerLed]);

  return { ...state, isSubscribed: state.status === 'active' };
}
